import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-125ee4b9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sms-campaigns-header" };
const _hoisted_2 = { class: "sms-campaigns-header__container" };
const _hoisted_3 = { class: "sms-campaigns-header__title" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsHeader',
    setup(__props) {
        const createCampaign = () => {
            mixpanelSmsCampaign.redirectCreateCampaign();
            router.push({
                name: 'campaign-sms-create',
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('sms-campaigns.header.title')), 1),
                    _createElementVNode("button", {
                        class: "btn",
                        onClick: createCampaign
                    }, _toDisplayString(_ctx.$t('sms-campaigns.header.button')), 1)
                ]),
                _hoisted_4
            ]));
        };
    }
});
